import { enqueueSnackbar } from 'notistack'
import {
  GqlViewerExamReserveInformationDocument,
  useGqlCreateExamReserveInformationMutation,
} from 'generated/graphql'
import { useChattingContext } from '@app.feature/chatting/chattingContext/module/ChattingContext'
import { TPreReservationFormValues } from '../constants/form'
import { SUCCESS_MESSAGE } from '../constants/message'
import { parsedCreateInputValues } from '../modules/form'

type TUseCreateExamReservationFn = (isDirty: boolean) => {
  createExam: (values: TPreReservationFormValues) => Promise<void>
}

const useCreateExamReservation: TUseCreateExamReservationFn = (isDirty) => {
  const [createExamReservation, { loading: createLoading }] =
    useGqlCreateExamReserveInformationMutation()
  const { reportToChatting } = useChattingContext()

  const createExam = async (
    values: TPreReservationFormValues,
  ): Promise<void> => {
    if (!isDirty || createLoading) return
    const input = parsedCreateInputValues(values)

    await createExamReservation({
      variables: {
        input,
      },
      refetchQueries: [GqlViewerExamReserveInformationDocument],
      onCompleted: () => {
        reportToChatting({
          type: 'reportChatRefreshMyChatRoom',
        })
        alert(SUCCESS_MESSAGE)
      },
      onError: (error) => {
        enqueueSnackbar(error.message)
      },
    })
  }
  return { createExam }
}

export default useCreateExamReservation
